import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  IconButton,
  Icon,
  Popover,
  MenuItem,
  Divider,
  Typography,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';

import AvatarProfile from '../../AvatarProfile';
import useStyles from './styles';
import Actions from '../../../store/ducks/auth';
// import AccessProfiles from '../../AccessProfiles';

const ProfileMenu = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const { name, email, avatar } = useSelector(({ userProfile }) => userProfile);
  // const [accessProfiles, toggleAccessProfiles] = React.useState(false);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(Actions.logout());
    handleClose();
  };

  return (
    <>
      <IconButton
        className={classes.btnMenu}
        aria-controls="profile"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <AvatarProfile avatar={avatar} name={name} size="small" />
      </IconButton>
      <Popover
        className={classes.container}
        id="profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box className="profile-infos">
          <AvatarProfile
            avatar={avatar}
            name={name}
            className="profile-infos-avatar"
            size="small"
          />
          <Typography className="profile-infos-name" variant="body2">
            <b>{name}</b>
          </Typography>
          <Typography className="profile-infos-email" variant="caption">
            {email}
          </Typography>
        </Box>
        <Divider />
        <MenuItem
          className="profile-menu-item"
          classes={{ root: classes.menuItemContainer }}
          onClick={handleClose}
          component={RouterLink}
          to="/profile"
        >
          <Icon className="profile-menu-item-icon">assignment_ind</Icon>
          <Typography variant="body2">Minha Conta</Typography>
        </MenuItem>
        {/* <MenuItem
          className="profile-menu-item"
          classes={{ root: classes.menuItemContainer }}
          onClick={() => {
            handleClose();
            toggleAccessProfiles(true);
          }}
        >
          <Icon className="profile-menu-item-icon">supervisor_account</Icon>
          <Typography variant="body2">Trocar perfil de acesso</Typography>
        </MenuItem> */}
        <MenuItem
          className="profile-menu-item"
          classes={{ root: classes.menuItemContainer }}
          onClick={handleLogout}
        >
          <Icon className="profile-menu-item-icon">exit_to_app</Icon>
          <Typography variant="body2">Sair</Typography>
        </MenuItem>
      </Popover>
      {/* <AccessProfiles
        isOpen={accessProfiles}
        handleClose={toggleAccessProfiles}
      /> */}
    </>
  );
};

export default ProfileMenu;
